<template>
    <v-container class="page-under-construction">
        <v-row column justify-center align-center no-gutters>
            <v-col cols="12"
                ><h2 class="pa-4 mb-0">
                    <TranslatableStringComponent :tstring="{string: 'pageUnderConstruction'}" />
                </h2></v-col
            >
        </v-row>
    </v-container>
</template>
<script>
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
export default {
    name: 'PageUnderConstruction',
    components: { TranslatableStringComponent, },
    props: {
        content: {
            type: Object,
            default: null
        }
    },
    computed: {},
    methods: {}
}
</script>
